export enum RotationPositions {
  bottom = 0,
  left = 90,
  top = 180,
  right = 270,
}
